export default "__VITE_ASSET__CV8JNQjz__"